import Decimal from "decimal.js";
import { formatPercentage } from "shared/utils/formattingUtils";

export const tryParseDecimal = (
  input: string | undefined | null,
): Decimal | undefined => {
  if (!input) {
    return undefined;
  }
  try {
    return new Decimal(input);
  } catch {
    return undefined;
  }
};

export const isValidDecimal = (value: string | undefined | null) =>
  Boolean(tryParseDecimal(value));

export const decimalOrZero = (input: string | null | undefined): Decimal =>
  tryParseDecimal(input) || decimalZero();

export const calculatePercentage = (
  totalValue: Decimal | undefined,
  value: Decimal | undefined,
): string => {
  if (!(totalValue && value)) {
    return "";
  }

  const percentage = value.div(totalValue).times(100);
  return formatPercentage(percentage, 2);
};

export const sumDecimalStrings = (
  decimalStrings: (string | null | undefined)[],
) =>
  decimalStrings.reduce(
    (acc, value) => acc.add(decimalOrZero(value)),
    decimalZero(),
  );

export const formatDecimalForTable = (value: string) => {
  const decimal = new Decimal(value);
  return decimal.isZero() ? "-" : decimal.toFormat();
};

export const decimalZero = () => new Decimal(0);
